
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/wallet",
      function () {
        return require("private-next-pages/my/wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/wallet"])
      });
    }
  